import { IItemList } from "@/components/core/Select";

export const SORT_OPTIONS: IItemList[] = [
  {
    label: "Subscribers",
    value: "subscribers"
  },
  {
    label: "Posts",
    value: "posts"
  },
  {
    label: "Name",
    value: "name"
  },
];

export const SORT_NAME_OPTIONS: IItemList[] = [
  {
    label: "A-Z",
    value: "alphabetical_asc"
  },
  {
    label: "Z-A",
    value: "alphabetical_desc"
  },
];
